/* Plugin. */
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import PropTypes from 'prop-types';
import withStyles from "isomorphic-style-loader/withStyles";
import { connect } from "react-redux";
import cx from 'classnames';

/* Component */
import WishListIcon from "../../../WishListIcon/WishListIcon";
import StarRating from "../../../StarRating/StarRating";
import CurrencyConverter from "../../../CurrencyConverter/CurrencyConverter";
import CommonListingPhotos from '../CommonListingPhotos/CommonListingPhotos'

/* Action and Helpers */
import messages from "../../../../locale/messages";
import { formatURL } from "../../../../helpers/formatURL";
import { CommonThunderBoltIcon } from "../../Assets/SvgComponent/commonSvgIcon";

/* Style. */
import s from './CommonListingItems.css';

const CommonListingItems = ({
    id,
    key,
    title,
    basePrice,
    currency,
    bookingType,
    isViewListing,
    account,
    reviewsCount,
    userId,
    reviewsStarRating,
    roomType,
    beds,
    coverPhoto,
    listPhotos,
    isListingSwiper,
    wishListStatus,
    personCapacity,
}) => {
    const currentUser = account?.userId;

    // Calculate star rating
    const starRatingValue = (reviewsCount > 0 && reviewsStarRating > 0)
        ? Math.round((reviewsStarRating / reviewsCount) * 10) / 10
        : 0;

    // Check if wishlist icon should be shown
    const isWhisListIcon = userId === currentUser;

    const personCapacityCount = personCapacity || 0;
    

    const renderPriceAndRating = () => (
        <div className={cx(s.textStrong, s.spaceTop2, s.textEllipsis, 'listingInfoRTL', s.pricingText, s.infoSpace)}>
            <div>
                <CurrencyConverter
                    amount={basePrice}
                    from={currency}
                />
                {' '}
                <span className={s.nightText}>
                    / <FormattedMessage {...messages.perNight} />
                </span>
                {bookingType === "instant" && (
                    <span>
                        <CommonThunderBoltIcon className7={s.instantIcon} />
                    </span>
                )}
            </div>
            {starRatingValue > 0 && (
                <div className={cx(s.infoReview, s.listReviewFlex)}>
                    <StarRating
                        className='bigStarRatingAdjust'
                        value={starRatingValue}
                        name={'review'}
                    />
                    <span>{starRatingValue}</span>
                </div>
            )}
        </div>
    );

    const renderListingInfo = () => (
        <>
            <div className={cx(s.textEllipsis, s.infoTitle, 'listingInfoRTL')}>
                <span className={'textReversing'}>{title}</span>
            </div>
            <div className={cx(s.textEllipsis, s.infoDesc)}>
                <span className='roomTypeRtl'>{roomType}</span>
                {personCapacityCount > 0 && (
                    <span>
                        <span>&nbsp;/&nbsp;</span>
                        {personCapacityCount} {personCapacityCount > 1
                            ? <FormattedMessage {...messages.guests} />
                            : <FormattedMessage {...messages.guest} />
                        }
                    </span>
                )}
            </div>
            
        </>
    );

    return (
        <div>
            <div className={cx(s.imgContainer)}>
                {!isWhisListIcon && (
                    <WishListIcon
                        listId={id}
                        key={key}
                        isChecked={wishListStatus}
                        isViewListing={isViewListing}
                    />
                )}
                <div className={cx(s.parent)}>
                    <div className={cx(s.children)}>
                        <div className={cx(s.content)}>
                            <CommonListingPhotos
                                id={id}
                                title={title}
                                className={cx(s.imageContent)}
                                coverPhoto={coverPhoto}
                                listPhotos={listPhotos}
                                photoType={"x_medium"}
                                bgImage
                                lazyLoad
                                placeholderClassName={cx(s.imageContent)}
                                isListingSwiper={isListingSwiper}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className={s.infoContainer}>
                <a
                    className={s.linkContainer}
                    href={`/rooms/${formatURL(title)}-${id}`}
                    target={'_blank'}
                    rel="noopener noreferrer"
                >
                    <div className='homeSliderRtl'>
                        {renderPriceAndRating()}
                        {renderListingInfo()}
                    </div>
                </a>
            </div>
        </div>
    );
};

CommonListingItems.propTypes = {
    id: PropTypes.number,
    photo: PropTypes.string,
    beds: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    basePrice: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    roomType: PropTypes.string.isRequired,
    bookingType: PropTypes.string.isRequired,
    listPhotos: PropTypes.array.isRequired,
    coverPhoto: PropTypes.number,
    reviewsCount: PropTypes.number,
    reviewsStarRating: PropTypes.number,
    wishListStatus: PropTypes.bool,
    account: PropTypes.object,
    isViewListing: PropTypes.bool,
    isListingSwiper: PropTypes.bool,
    userId: PropTypes.string,
    personCapacity: PropTypes.number,
};

const mapState = (state) => ({
    account: state.account.data
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(injectIntl(withStyles(s)(CommonListingItems)));